import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import ResourceType from '../../types/resource';

import './table-list-item.css';

const TableListItem = ({ isSelected, resource, onSelect, onChangeLocation }) =>
{
  const {
    name,
    isDirectory,
    isDocument,
    isImage,
    size,
    accessLevel,
    date
  } = resource;

  const itemClass = classnames({
    'resource-dialog__table-list-item': true,
    'resource-dialog__table-list-item_selected': isSelected
  });

  const iconClass = classnames({
    'resource-dialog__table-list-item-icon': true,
    'resource-dialog__table-list-item-icon_directory': isDirectory,
    'resource-dialog__table-list-item-icon_document': isDocument
  });

  const sizeLabel = !isDirectory && `${Math.round(size / 1024)} Kb`;

  return (
    <div className={itemClass} onClick={onSelect} onDoubleClick={onChangeLocation}>
      <div className="resource-dialog__table-list-item-field resource-dialog__table-list-item-field_label">
        <div className="resource-dialog__table-list-item-label">
          <div className={iconClass}></div>
          <label
            className="resource-dialog__table-list-item-name"
            data-test-id="idIRD_fileName"
          >{name}</label>
        </div>
      </div>
      <div
        className="resource-dialog__table-list-item-field resource-dialog__table-list-item-field_access"
        data-test-id="idIRD_fileAccessLevel"
      >
        {accessLevel}
      </div>
      <div
        className="resource-dialog__table-list-item-field resource-dialog__table-list-item-field_date"
        data-test-id="idIRD_fileDate"
      >
        {moment(date).format("MM-DD-YYYY")}
      </div>
      <div
        className="resource-dialog__table-list-item-field resource-dialog__table-list-item-field_size"
        data-test-id="idIRD_fileSize"
      >
        {sizeLabel}
      </div>
      <div className="resource-dialog__table-list-item-field resource-dialog__table-list-item-field_delete">
        <a href="#" className="resource-dialog__link">Delete</a>
      </div>
    </div>
  );
};

TableListItem.propTypes = {
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onChangeLocation: PropTypes.func.isRequired,
  resource: ResourceType.isRequired
};

TableListItem.defaultProps = {
  isSelected: false
};

export default TableListItem;